
import { Box, Toast, View } from "native-base";
import { ActivityIndicator, Text, TextInput, TouchableHighlight, TouchableOpacity } from "react-native";
import Fontisto from '@expo/vector-icons/Fontisto';
import Feather from '@expo/vector-icons/Feather';
import { useState } from "react";
import { UserAPI } from "../../data/api";

const ConfigUserModal = ({
  setOpen,
  onChange
}:{
  setOpen: (open: boolean) => void;
  onChange: ()=> void;
}) => {
  const [counLoad, setCountLoad] = useState(false);
  const [cachePhone, setCachePhone] = useState<string>("");

  const bindingPhone = async ()=>{
    if(!cachePhone){
      Toast.show({
        title: "Please enter phone number",
        placement: "top",
        bgColor: "rgba(255,0,0,0.4)",
      });
      return;
    }
    setCountLoad(true);
    let res = await UserAPI.updateUserPhone(cachePhone);
    setCountLoad(false);
    if(!res){
      Toast.show({
        title: "Binding failed",
        placement: "top",
        bgColor: "rgba(255,0,0,0.4)",
      });
      
    }else{
      Toast.show({
        title: "Binding Success",
        placement: "top",
        bgColor: "rgba(0,255,0,0.4)",
      });
      setOpen(false);
    }
  }
  
  return (
    <View style={{ width: "100%", alignItems: "center" }}>
      <Feather name="user" size={48} style={{ fontWeight: "900" }} color="#FFFFFF" />
      <Text style={{
        color: "#FFFFFF", fontSize: 20, fontWeight: "bold",
        marginTop: 16, textAlign: "center"
      }}>
        Bind phone number
      </Text>
      <Text style={{
        color: "#FFFFFF", fontSize: 20, fontWeight: "bold",
        marginBottom: 16, textAlign: "center"
      }}>
        Prevent data loss
      </Text>
      <Box style={{ flexDirection: "row", gap: 10, alignItems: "center" }}>
        <TextInput placeholder="+1 XXXX" placeholderTextColor="#999999"
          onChangeText={(e)=>{ setCachePhone(e) }}
          style={{
            width: 300, height: 40, backgroundColor: "rgb(33,35,58)",
            borderRadius: 10, paddingLeft: 10, paddingRight: 10,
            color: "#FFFFFF", fontSize: 16,
            borderWidth: 2,
            borderColor: "rgb(179,88,251)"
          }} />
      </Box>
      <View style={{ height: 60, padding: 10, marginTop: 20 }}>
        <TouchableHighlight style={{
          height: 40, borderRadius: 6, paddingLeft: 10, paddingRight: 10,
          width: 300,
          backgroundImage: "linear-gradient(to bottom, rgb(148,9,255), rgb(173,8,255))",
          alignItems: "center", justifyContent: "center"
        }} onPress={bindingPhone}>
          {counLoad ? (
            <ActivityIndicator size="large" color="#FFFFFF" />
          ):(
            <Text style={{ fontSize: 18, color: "#FFFFFF", fontWeight: "700" }}>
              Countinue
            </Text>
          )}
        </TouchableHighlight>
      </View>
      <TouchableOpacity onPress={()=> setOpen(false) }>
        <Text style={{
          textDecorationLine: "underline",
          textDecorationColor: "#CCCCCC",
          textDecorationStyle: "solid",
          fontSize: 16, color: "#FFFFFF",
        }}>
          Set later
        </Text>
      </TouchableOpacity>
    </View>
  )
};

export default ConfigUserModal;